import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const TasksPage = lazy(() => import("./web/TasksPage.js").then((m) => ({ default: m.TasksPage })));
const ManagePage = lazy(() => import("./web/ManagePage.js").then((m) => ({ default: m.ManagePage })));
const ChecksPage = lazy(() => import("./web/ChecksPage.js").then((m) => ({ default: m.ChecksPage })));

export default defineWebModule({ manifest, pages: { "": TasksPage, "/manage": ManagePage, "/checks": ChecksPage } });
